module.exports = __webpack_public_path__ + "img/19_6.d1238c10.png";